import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get Panel
export const getPaymentReceive = createAsyncThunk("/getlist-purchase-receive", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.get(`${baseUrl}cleaningappfunctions//finance/app/v1/getlist-purchase-receive`, data, { 
            headers: {
                "auth-token": token,
            }
        },);
        return response;
    } catch (error) {
        console.error('Error fetching panel- ', error);
        throw error;
    }
})


